// import { Button, Link } from "pathwright-ui"import { useBlocksConfig } from "@pathwright/blocks-engine"
import { useBlocksConfig } from "@pathwright/blocks-engine"
import {
  LazyVideoPlayer,
  MuxVideoEditor
} from "@pathwright/legacy-media-manager"
import {
  // Row,
  VideoBlockWrapper
} from "./ui"

export const VideoView = ({ data, layout, id }) => {
  // This is a global school setting based on a feature flag
  const { allowDownloadableVideos } = useBlocksConfig()

  const {
    downloadURL,
    coverImage,
    originalThumb,
    type,
    height,
    width,
    streamURL,
    allowDownload, // this is a per-video setting from the Designer
    muxVideoID
  } = data

  const { contextKey } = useBlocksConfig()

  return (
    <VideoBlockWrapper layout={layout} className="VideoWrapperView">
      {!!muxVideoID ? (
        <MuxVideoEditor
          video={{ id: muxVideoID }}
          coverImage={coverImage}
          allowDownload={
            allowDownload && (allowDownloadableVideos || downloadURL)
          }
          contextKey={`video-block-view-${id}-${contextKey}`}
        />
      ) : (
        // This is a legacy/Filestack video
        <LazyVideoPlayer
          src={streamURL}
          downloadURL={downloadURL}
          allowDownload={allowDownload || false}
          coverImage={coverImage || originalThumb}
          type={type}
          height={height}
          width={width}
          fullWidth={layout === "fullwidth"}
        />
      )}
    </VideoBlockWrapper>
  )
}

export default VideoView
